import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { forwardRef } from "react";

const Alert = forwardRef<HTMLDivElement, AlertProps>(
  function Alert(props, ref) {
    return (
      <MuiAlert
        sx={{ minWidth: "30ch" }}
        elevation={6}
        ref={ref}
        variant="filled"
        {...props}
      />
    );
  }
);

export default Alert;
